import React, { CSSProperties } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyHoverTextField = styled(Box, {
    name: 'StyHoverTextField',
})({
    whiteSpace: 'pre-wrap',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    lineHeight: '1.3',
    width: '100%',
});

type Props = {
    value?: string | null;
    customStyle?: CSSProperties;
};

export default function TextHoverTooltip({
    value = '',
    customStyle = {},
}: Props): React.ReactElement {
    return (
        <Tooltip title={value}>
            <StyHoverTextField style={customStyle}>{value}</StyHoverTextField>
        </Tooltip>
    );
}
